export enum LocalStorageKey {
  consultantVanityName = 'consultantVanityName',
  partyId = 'partyId',
  isCartUpdated = 'isCartUpdated',
  toVerifyPhoneNumber = 'toVerifyPhoneNumber',
}
